export default __webpack_public_path__ + "static/media/group-13-copy.eecc7365.svg";